var voted_users_rtlignore_default = {
  "container": "pGyvO",
  "webview": "_1xTa5",
  "avatar_list": "-szTR",
  "avatar": "NOLpR",
  "user_avatar": "ln-DI",
  "modal": "_2Usok",
  "voted_users_modal": "OQamw",
  "overlay": "yCOKt",
  "user_card": "HY6Tr",
  "user_name": "TuW-P",
  "voted_users_modal_header": "EzoxR",
  "cta": "ig3kH",
  "close_icon": "_32JOF",
  "title": "_1BJlq",
  "member_list_container": "Swtz3",
  "member_list": "_1-JQk",
  "loader": "w-DKU",
  "anonymous_counter": "ryxsl",
  "spinner": "Rm-an",
  "spin": "CqMiO"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
